import { GlobalDataContext } from "@/app/context/global/globalDataContext";
import { CreatureDefinitionType } from "@/app/types/creatureDefinitionType";
import { Avatar, Box, Progress } from "@chakra-ui/react";
import { ReactElement, createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { AuthenticationContext } from "@/app/context/authentication/authenticationContext";
import { GlobalDataUserContext } from "@/app/context/global/globalDataUserContext";
import { Source, Layer, MapRef, Marker } from 'react-map-gl';
import * as turf from '@turf/turf';
import { NotificationContext } from "@/app/context/notification/notificationContext";
import { doesZoneOverlapWithExisting, getDistance, insideGeojson, validatePolygonIfNeeded } from "@/app/helpers/mapHelper";
import { capitalizeFirstLetter } from "@/app/helpers/stringHelper";
import { ZoneType } from "@/app/types/zoneType";
import { captureCreatureMessage, creatureCloseMessage, finishGameNotConnectedMessage, firstEggMessage, loosehGameMessage, startGameMessage, startGameQuestMessage } from "@/app/context/notification/helper/anaDiscussionHelper";
import { FirebaseContext } from "@/app/context/firebase/firebaseContext";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { buildChaseUrl, buildGameUrl } from "@/app/helpers/buildUrlHelper";
import { TiStarFullOutline } from "react-icons/ti";
import FinishGameModal from "./layout/modal/finishGameModal";
import LooseGameModal from "./layout/modal/looseGameModal";
import LeaderBoardModal from "./layout/modal/leaderBoardZoneModal";
import { FaEgg, FaStar } from "react-icons/fa6";
import { GiCupcake } from "react-icons/gi";
import { storeDataWithDateLocalStorageHelper } from "@/app/helpers/localStorageHelper";
import { GameQuestType } from "@/app/context/game/types/gameQuestType";
import { QuestType } from "./types/questType";
import { v4 } from "uuid";
import { calculateElevationGain, generateRandomPath, getCenter, getRoute } from "@/app/helpers/generateRandomPathHelper";
import { set } from "lodash";
import { AllQuestModelConst } from "@/app/const/allQuestModelConst";
import { QuestModelType } from "./types/questModelType";
import FinishQuestModal from "./layout/modal/finishGameQuest";
import { TbDiamondFilled } from "react-icons/tb";
import NewDynamicItemModal from "./layout/modal/newDynamicItemModal";
import { GameContext } from "./gameContext";

export const GameQuestContext = createContext({} as GameQuestType);

export const GameQuestProvider = (props:any) => {

    const {t} = useTranslation();
    const router = useRouter()
    const mapRef = useRef<MapRef | null>(null);
    const [gameKilometers, setGameKilometers] = useState<number>(0)
    const [quest, setQuest] = useState<QuestType>({}as QuestType);
    const [insideZone, setInsideZone] = useState<string|undefined>();
    const [isDarkMode, setIsDarkMode] = useState(false);
    const [isGenerating, setIsGenerating] = useState(false);
    const [closeToMonster, setCloseToMonster] = useState(false);
    const [doResize, setDoResize] = useState(false);
    const [coords, setCoords] = useState<any[]>([]);
    const [allCoords, setAllCoords] = useState<any[]>([]);
    const [sizePath, setSizePath] = useState<number>(1);

    const [distance, setDistance] = useState(0)
    const [duration, setDuration] = useState(0)
    const [difficulty, setDifficulty] = useState<string>("easy");
    const [elevations, setElevations] =useState<number[]>([])
    const [totalGain, setTotalGain] = useState(0)
    const easyThreshold = 150; // en mètres
    const mediumThreshold = 250; // en mètres

    const {
        language,
        location,
        questId,
        categoryId,
        firstLocation,
        distanceLocation,
        isRaining,
    } = useContext(GlobalDataContext)
    
    const {
        user,
        cloudStorage
    } = useContext(AuthenticationContext)
    
    const {
        myZones,
        setMyZones,
        addNewCreature,
        addKilometersReducer,
        addOrUpdateActionHistory,
        play,
        config,
        userInfo,
        allPlayersPositions,
        allItems,
        setAllItems,
        addNewEgg,
        addFood,
        anaDiscussionStatus,
        updateAnaDiscussionStatus,
        addArtifactIfNotExist
    } = useContext(GlobalDataUserContext)

    const {
        setDoVibrate,
        addMessageWithId,
        isRecentMessage,
        addModalToQueue,
        character
    } = useContext(NotificationContext)

    const {
        logAnalyticsEvent
    } = useContext(FirebaseContext)

    useEffect(() => {
        // Mettre à jour le style au premier rendu
        updateDarkMode();
    
        // Configurer un intervalle pour vérifier l'heure toutes les minutes
        const interval = setInterval(() => {
            updateDarkMode();
        }, 60000); // 60000 ms = 1 minute
    
        // Nettoyer l'intervalle quand le composant est démonté
        return () => clearInterval(interval);
    }, []);

    useEffect(()=>{
        if ( questId && questId !=="0"){
            const quest = AllQuestModelConst.find(q => q.id === questId)
            if ( quest) {
              setQuest({
                  id: v4(),
                  modelQuest: quest,
                  timestamp : new Date().getTime(),
                  status: "pending"
              })
            }            
        }
    },[questId])

    useEffect(()=>{
        if ( quest.status == "started"){
            if ( gameKilometers + distanceLocation >= 250){
                addKilometersReducer(gameKilometers + distanceLocation)
                setGameKilometers(0)
                addOrUpdateActionHistory("kilometer",gameKilometers + distanceLocation)
            }else{
                setGameKilometers(gameKilometers + distanceLocation)
            }
        }
    },[distanceLocation])



    useEffect(()=>{
        setDoResize(true)       
    },[myZones, questId])

    useEffect(()=>{
        if ( doResize){
            setDoResize(false)
        }
    },[doResize])

    /*useEffect(()=>{
        if (quest.status=="started"){
            setDoResize(true)
            const numberOfCheck = quest.modelQuest.element.filter(element => element.checked).length
            if ( numberOfCheck == quest.modelQuest.element.length){
                winQuest()
            }
        }
    },[quest])*/

    const winQuest= ()=>{
        setQuest(prevQuest => ({...prevQuest, status: 'finished'}));
        
        addModalToQueue({
            component: FinishQuestModal,
            props: {},
            doConfetti: true,
            doVibrate: true,
            onShow: ()=>{play("win01")}
        })
        if ( quest.modelQuest.private) {
          const uuid = v4()
          router.push(buildChaseUrl(language, categoryId, uuid), undefined, { shallow: true }).then()
        }else{
          router.push(buildGameUrl(language, categoryId, undefined), undefined, { shallow: true }).then()
        }
    }

    const updateDarkMode = () => {
        const hour = new Date().getHours();
        if (hour >= 18 || hour < 6) {
          setIsDarkMode(true);
        } else {
          setIsDarkMode(false);
        }
    };

    useEffect(()=>{
      if ( quest && quest.modelQuest && !quest.modelQuest?.unblocked) {
        const totalUnblocked = quest.modelQuest.element.filter(element => element.unblocked).length 
        const totalUnblockItem = quest.modelQuest.element.filter(element => element.unblockItem).length 
        if ( totalUnblocked == totalUnblockItem ){ 
          play("magic01")
          setQuest(prevQuest => ({
            ...prevQuest,
            modelQuest: {...prevQuest.modelQuest, element: prevQuest.modelQuest.element.map((el, index) => 
              index === 0 ? { 
                ...el, 
                items: "artifact",
                checked: false,
                soundBefore: null,
                messageBefore: null,
                messageAfter: null,
                actionBefore: false,
                icon: <TbDiamondFilled style={{width:"32", height:"32"}}/>
               } : el
            ),unblocked: true}
          }))
          if ( quest.modelQuest.messageUnblocked){
            addMessageWithId("unblockMessage"+v4(), quest.modelQuest.messageUnblocked[language], "message", "unread", null)
          }
        }
      }
    },[quest])

    useEffect(()=>{
      if ( quest.status == "started" && location){
        let indexToChange = -1
        let indexToChangeBefore = -1
        let unblock=false
        quest.modelQuest.element.forEach((element,index) => {
          if ( element.position) {
            const distance = getDistance({latitude:location?.lat,longitude:location?.lng}, {latitude:element.position?.lat,longitude:element.position?.lng});
            if ( distance < 14 && !element.checked){
              if ( element.unblockItem){
                unblock = true
              }
              indexToChange = index
              if ( element.items == "egg"){
                addNewEgg(isRaining?"AQUATIC":"NORMAL", true) 
                if ( !anaDiscussionStatus?.gotFirstEgg ){
                    firstEggMessage(addMessageWithId, t, character?.translationKey)
                    updateAnaDiscussionStatus("SET_NEW_EGG", true)                    
                }
              } else if ( element.items == "eggFlying"){
                addNewEgg("FLYING", true) 
                if ( !anaDiscussionStatus?.gotFirstEgg ){
                    firstEggMessage(addMessageWithId, t, character?.translationKey)
                    updateAnaDiscussionStatus("SET_NEW_EGG", true)                    
                }
              } else if ( element.items == "food"){
                addFood(10)
              }
              if ( element.messageAfter){
                addMessageWithId("elementMessage"+v4(), element.messageAfter[language], "message", "unread", null)
              }
              if ( element.details && !element.checked && element.details.name){
                addModalToQueue({
                    component: NewDynamicItemModal,
                    props: { 
                        name: element.details.name[language],
                        url: element.details.url,
                        description:t("game.youGotItem")
                    },
                    doConfetti: true,
                    doVibrate: true,
                    onShow:()=>{play("woohoo01")}
                })
              }
              if ( quest.modelQuest.artifact && element.items == "artifact"){
                addArtifactIfNotExist({
                  id: quest.modelQuest.artifact.id,
                  name: quest.modelQuest.artifact.name,
                  url: quest.modelQuest.artifact.url
                })
                addModalToQueue({
                    component: NewDynamicItemModal,
                    props: { 
                        name: quest.modelQuest.artifact.name,
                        url: quest.modelQuest.artifact.url,
                        description:t("game.youGotArtifact")
                    },
                    doConfetti: true,
                    doVibrate: true,
                    onShow:()=>{play("woohoo01")}
                })
                winQuest()
              }
            }else if ( distance < 24 && !element.checked && !element.actionBefore){
              indexToChangeBefore = index
              if ( element.messageBefore){
                addMessageWithId("elementMessage"+v4(), element.messageBefore[language], "message", "unread", Date.now() + 3000)
              }
              if ( element.soundBefore){
                play(element.soundBefore)
              }
            }
          }
        })

        if ( indexToChange > -1 ){
          setQuest(prevQuest => ({
            ...prevQuest,
              modelQuest: {...prevQuest.modelQuest, element:prevQuest.modelQuest.element.map((element, index) => {
              if ( index == indexToChange && element.position){
                return {
                  ...element,
                  checked: true,
                  unblocked: unblock
                }
              }
              return element
            })}
          }))
        }

        if ( indexToChangeBefore > -1 ){
          setQuest(prevQuest => ({
            ...prevQuest,
              modelQuest: {...prevQuest.modelQuest, element:prevQuest.modelQuest.element.map((element, index) => {
              if ( index == indexToChangeBefore && element.position){
                return {
                  ...element,
                  actionBefore: true
                }
              }
              return element
            })}
          }))
        }
      }
    },[location])

    const increaseQuizzSuccessCount =()=>{
      setQuest(prevQuest => ({
        ...prevQuest,
        modelQuest: {...prevQuest.modelQuest, quizzSuccessCount: (prevQuest.modelQuest.quizzSuccessCount??0)+1}
      }))
    }

    const regenGame = useCallback(() => {
      if ( user ) {
        setIsGenerating(true);
        const result = generateRandomPath(location,sizePath)   
        if ( result && result.length){
          setCoords(result)        
          if ( mapRef && mapRef.current) {
            mapRef.current.getMap().setCenter(getCenter([result[0],result[1],result[2]]));
          }
          getRoute([...result,result[0]],user, true).then(result=>{
            if ( result && result.coords && result.coords.length) {
                setAllCoords(result.coords)
                setDistance(result.distance)
                setDuration(result.duration)
                setElevations(result.elevation)
                const { totalGainCalc } = calculateElevationGain(result.elevation);
                setTotalGain(totalGainCalc)
                if (totalGainCalc < easyThreshold) {
                  setDifficulty('easy')
                } else if (totalGainCalc < mediumThreshold) {
                  setDifficulty('medium')
                } else {
                  setDifficulty('hard')
                }                
            }
            setIsGenerating(false)  
            setDoResize(true);  
          })         
        }
      }
          
    }, [generateRandomPath, user, location, sizePath]);



    const startGame = useCallback(() => {             
        const totalCoords = allCoords.length;
        const countElement = quest.modelQuest.element.length;

        let mirrorElement = quest.modelQuest.element
        if ( quest.modelQuest.type == "RANDOM") {
          mirrorElement = quest.modelQuest.element.map((element, index) => {
            return {
              ...element,
              position: {
                lat:allCoords[Math.round(((index) / countElement) * totalCoords)][1],
                lng:allCoords[Math.round(((index) / countElement) * totalCoords)][0]
              }                
            }
          })
        }
        setQuest((prevQuest) => ({
          ...prevQuest,
          modelQuest: {...prevQuest.modelQuest,element: mirrorElement},
          status: "started"
        }));
        setGameKilometers(0);
        //startGameQuestMessage(addMessageWithId, t);
        addOrUpdateActionHistory("playQuest", 1);
        logAnalyticsEvent("quest", {});      
    }, [ addMessageWithId, t, addOrUpdateActionHistory, logAnalyticsEvent, allCoords,quest]);


    const geoJson:GeoJSON.FeatureCollection  = useMemo(() => {
        return {
          "type": "FeatureCollection",
          "features": [
            {
              "type": "Feature",
              "geometry": {
                "type": "LineString",
                "coordinates": [...allCoords]
              },
              properties: {},
            }
          ]
        }
    },[allCoords])
/*
    const questModel = useMemo(():QuestModelType|undefined => {  
      return AllQuestModelConst.find(q => q.id === questId);
    }, [questId]);
*/
    const numberOfItemsToGet = useMemo(():number=> {
      if ( quest && quest.modelQuest && quest.modelQuest.element){
        return quest.modelQuest.element.filter(element => element.unblockItem).length
      }
      return 0
    } ,[quest])

    const numberOfItemsFounded = useMemo(():number=> {
      if ( quest && quest.modelQuest && quest.modelQuest.element){
        return quest.modelQuest.element.filter(element => element.unblocked).length
      }
      return 0
    } ,[quest])

    const renderPolygons = useMemo((): ReactElement | undefined => {
        if (!allCoords || allCoords.length === 0) return undefined;
        return (
          <>
            {quest && quest.modelQuest && !quest.modelQuest.hidePath==true && <Source id="route" type="geojson" data={geoJson}>
              <Layer
                id="route"
                type="line"
                layout={{
                  'line-join': 'round',
                  'line-cap': 'round'
                }}
                paint={{
                  'line-color': 'dodgerblue',
                  'line-width': 4
                }}
              />
            </Source>}
            {quest && quest.modelQuest && quest.modelQuest.element.map((element, index) => {
              if (element.position && ! (!element.checked==true && quest.modelQuest.hidePath)) {
                return (
                  <Marker key={index} longitude={element.position.lng} latitude={element.position.lat}>
                    {!element.icon && <Box
                      bg={element.checked?"#5ab400":(element.actionBefore?"orange":"white")}
                      color={element.checked?"white":"black"}
                      border="3px solid #cfcfcf"
                      p={2}
                      borderRadius="50%"
                      boxShadow="md"
                      fontSize="sm"
                    >
                    </Box>}
                    {element.icon && element.unblockItem && <Box
                      bg={element.checked?"#5ab400":("white")}
                      color={element.checked?"white":"black"}
                      p={2}
                      boxShadow="md"
                      fontSize="sm"
                      position="relative"
                      borderRadius= '50%'
                    >
                      {element.icon}
                    </Box>}
                    {element.icon && !element.unblockItem && <Box
                      color={element.checked?"5ab400":(isDarkMode?"white":"black")}
                      p={1}
                      fontSize="sm"
                      position="relative"
                      borderRadius= '50%'
                    >
                      {element.icon}
                    </Box>}
                  </Marker>
                );
              }
            })}
          </>
        );
      }, [allCoords,quest.modelQuest]);
      
     

    return (
        <GameQuestContext.Provider value={{
            mapRef: mapRef,
            quest,
            insideZone,
            isDarkMode,
            closeToMonster,
            startGame,
            renderPolygons: ()=>renderPolygons,
            doResize,
            setDoResize,
            regenGame,
            distance,
            duration,
            difficulty,
            elevations,
            totalGain,
            setSizePath,
            sizePath,
            isGenerating,
            increaseQuizzSuccessCount,
            numberOfItemsToGet,
            numberOfItemsFounded
        }}>
            {props.children}
        </GameQuestContext.Provider>
    )
}